export function SvgIcon({ href, size }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox={`0 0 ${size} ${size}`}>
            {/* NOTE: we expect svg file have element with id=`icon${size}` AND this element have `${size}x${size}px` dimensions */}
            <use href={`${href}#icon${size}`} />
        </svg>
    );
}
